import {Link} from 'react-router-dom';
import {ArrowUpRight} from '@phosphor-icons/react';
import {useTenantContext} from '@/app/TenantContext';
import {tenantPath} from '@/lib/tenant/resolve';

/** Подвал страниц: тонкая линия, название студии слева, «Связаться» справа. */
export function TenantFooter() {
  const {tenant, slug} = useTenantContext();
  return (
    <div className="mx-4 mt-auto flex items-center justify-between gap-3 border-t border-white/10 pb-6 pt-5">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="truncate text-[15px] text-muted-foreground">{tenant.name}</span>
        <Link to={tenantPath(slug, 'privacy')} className="text-[13px] text-muted-foreground underline">
          Политика конфиденциальности
        </Link>
      </div>
      {tenant.phone ? (
        <a href={`tel:${tenant.phone}`} className="flex items-center gap-2 text-[15px] text-muted-foreground">
          Связаться
          <ArrowUpRight size={18} aria-hidden />
        </a>
      ) : null}
    </div>
  );
}
